var render = function render(){var _vm=this,_c=_vm._self._c;return _c('UserList',_vm._b({},'UserList',_vm.$props,false))
}
var staticRenderFns = []

export { render, staticRenderFns }